import React, { useState } from 'react';
import { Form, Input, Button, Icon, Radio, Tooltip, Alert, Select, DatePicker } from 'antd';
import { TransferRequest } from '../../../../models';
import { TransferTypeCard } from './styles';
import { Text4 } from '../../../../styles';
import { PAYMENT_METHODS, PROVIDER_PAYMENT_MODE_MESSAGES } from '../../../../constants';
import { MerchantService } from '../../../../services';
import { handleApiExceptions, printRupee, alertify } from '../../../../app_methods';
import { connect } from 'react-redux';
import { getBankLogo } from '../../../../constants';
import './index.scss';
import moment from 'moment';


let TransferRequestForm = (props) => {
    const [disabledFields, setDisabledFields] = useState({
        "NEFT": false,
        "RTGS": true,
        "IMPS": false,
        "UPI": false
    });
    const [isGenerating, setIsGenerating] = useState(false);
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);

    const { form, beneficiary } = props;
    const { getFieldDecorator } = form;
    const validations = TransferRequest.validations;
    const account_type = (beneficiary.beneficiary_type) || null;

    const generateUniqueRequestNumber = () => {
        setIsGenerating(true);
        MerchantService.generate_urn().then(response => {
            if (response.success) form.setFieldsValue({"unique_request_number": response.data.unique_request_number})
            setIsGenerating(false);
        }).catch(error => {
            setIsGenerating(false);
            handleApiExceptions(error);
        })
    };

    function disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
    }

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            let payment_mode = form.getFieldValue("payment_mode")
            let txn_limit = props.current_user.tl;
            if(payment_mode in txn_limit && txn_limit[payment_mode] && form.getFieldValue('amount') > txn_limit[payment_mode]){
                alertify("Oops!", `Amount exceeds transaction limit of Rs. ${parseFloat(txn_limit[payment_mode]).toFixed(2)} for ${payment_mode}.`, "error");
                return;
            }
            props.onSubmit(form.getFieldsValue());
        });
    };

    const handleAmountChange = (e) => {
        const amount = parseFloat(e.target.value);
        if (isNaN(amount)) return;
        let _disabledFields = { ...disabledFields };

        if (account_type == "upi") {
            _disabledFields["UPI"] = amount < 1 || amount > 100000;
        }
        else {
            _disabledFields["NEFT"] = amount < 1;
            _disabledFields["RTGS"] = amount < 200000;
            _disabledFields["IMPS"] = amount < 1 || amount > 500000;
        }
        setDisabledFields(_disabledFields);
        if (props.form.getFieldValue("payment_mode") == "RTGS" && amount <= 500000) props.form.setFieldsValue({ payment_mode: "IMPS" });
        else if (props.form.getFieldValue("payment_mode") == "IMPS" && amount > 500000) props.form.setFieldsValue({ payment_mode: "RTGS" });
    };

    const renderTransferTypes = () => {
        return (
            <Radio.Group className="w-100 d-flex">
                {
                    PAYMENT_METHODS.filter(pm => pm.payment_type == account_type).map((pm, index) =>
                        <TransferTypeCard className={`mr-1 ${disabledFields[pm.value] ? "transfer-type-card-disabled" : ""}`} style={{ maxWidth: 215 }}>
                            <div className="d-flex align-items-start">
                                <Radio id={index} value={pm.value} disabled={disabledFields[pm.value]}></Radio>
                                <label htmlFor={index}>
                                    <Text4 className="d-block" style={{ lineHeight: "20px" }}>{pm.label}</Text4>
                                    <Text4 className="d-block" type="secondary">{pm.description.amount}</Text4>
                                    <Text4 className="d-block" type="secondary">{pm.description.time}</Text4>
                                </label>
                            </div>
                        </TransferTypeCard>
                    )
                }
            </Radio.Group>
        )
    };

    const renderURNExtra = () => {
        return (
            <Tooltip title="Generate Random">
                <Icon type="setting" spin={isGenerating} onClick={generateUniqueRequestNumber} />
            </Tooltip>
        )
    };

    return (
        <Form className={`transfer-request-form-wrapper ${props.className}`} onSubmit={onSubmit}>
            {getFieldDecorator("beneficiary_code", {
                initialValue: beneficiary.code || "",
            })(<Input autoComplete='off' hidden />)}

            {getFieldDecorator("queue_on_low_balance", {
                initialValue: props.current_user.eqlb
            })(<Input autoComplete='off' hidden />)}

            <Form.Item label="Source Virtual Account">
                {getFieldDecorator("virtual_account_number", {
                        rules: TransferRequest.validations.virtual_account_number,
                        initialValue: props.current_user.virtual_account.virtual_account_number
                    })(<Select>
                        {
                            props.current_user.virtual_accounts.filter(va => va.status == "active").map((va, index) => {
                                return (
                                    <Select.Option value={va.virtual_account_number} disabled={va.funding_via==2 && !props.current_user.allow_payouts_via_cc_va? true : false}>
                                        <div className="d-flex">
                                            <div
                                                style={{
                                                    display: "flex",
                                                    width: 28,
                                                    overflow: "hidden",
                                                    textAlign: "center",
                                                    marginRight: 8
                                                }}
                                            >
                                                <img
                                                    style={{
                                                        margin: "auto",
                                                        width: "auto",
                                                        maxWidth: "100%",
                                                        maxHeight: 28
                                                    }}
                                                    alt=""
                                                    src={getBankLogo(va.provider_code)}
                                                />
                                            </div>
                                            <Text4 className="mr-1">{va.label}</Text4>
                                            <Text4 className="mr-1">·</Text4>
                                            <Text4 type="secondary">Available Balance: {printRupee(va.balance, 3)}</Text4>
                                        </div>
                                    </Select.Option>
                                )
                            })
                        }
                    </Select>)}
            </Form.Item>

            <Form.Item label="Amount">
                {getFieldDecorator("amount", {
                    rules: validations.amount
                })(<Input autoComplete='off' prefix={<span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />} onChange={handleAmountChange} />)}
            </Form.Item>
            {!props?.current_user?.enable_custom_irn_for_tr ?
                <Form.Item label="Unique Request Number">
                    {getFieldDecorator("unique_request_number", {
                        rules: validations.unique_request_number
                    })(<Input autoComplete='off' prefix={<Icon type="audit" />} addonAfter={renderURNExtra()} />)}
                </Form.Item>:
                <Form.Item label="Unique Request Number">
                    {getFieldDecorator("unique_request_number", {
                        rules: validations.custom_unique_request_number
                    })(<Input autoComplete='off' prefix={<Icon type="audit" />} addonAfter={renderURNExtra()} />)}
                </Form.Item>
            }

            <Form.Item className="mt-2" label="Payment Method">
                {getFieldDecorator("payment_mode", {
                    rules: validations.payment_mode,
                    initialValue: account_type == "upi" ? "UPI" : "IMPS"
                })(renderTransferTypes())}
            </Form.Item>

            {
                PROVIDER_PAYMENT_MODE_MESSAGES[props.current_user.virtual_account.provider_code]
                &&
                PROVIDER_PAYMENT_MODE_MESSAGES[props.current_user.virtual_account.provider_code][form.getFieldValue('payment_mode')]
                ?
                    <Alert
                        className="mb-2"
                        type="info"
                        message={PROVIDER_PAYMENT_MODE_MESSAGES[props.current_user.virtual_account.provider_code][form.getFieldValue('payment_mode')].node}
                        icon={<Icon type="info-circle" />}
                        showIcon
                    /> : null
            }

            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item label="Narration">
                        {getFieldDecorator("narration", {
                            rules: validations.narration
                        })(<Input autoComplete='off' prefix={<Icon type="edit" />} />)}
                    </Form.Item>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <Form.Item autoComplete='off' label="Schedule for later">
                        {getFieldDecorator("scheduled_for", {
                            rules: validations.scheduled_for
                        })(
                            <DatePicker
                                style={{ width: "100%" }}
                                format="YYYY-MM-DD"
                                disabledDate={disabledDate}
                            />
                        )}
                    </Form.Item>
                </div>
            </div>

            <Button
                className="pl-0 mb-2"
                type="link"
                onClick={() => setShowAdvancedOptions(!showAdvancedOptions)}
            >
                {showAdvancedOptions ? "Hide Advanced Options" : "Show Advanced Options"}
                <Icon type={showAdvancedOptions ? "down" : "right"} />
            </Button>

            {
                showAdvancedOptions ?
                <div className="d-flex">
                    <Form.Item label="UDF 1">
                        {getFieldDecorator("udf1", {
                            rules: validations.udf1
                        })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                    </Form.Item>

                    <Form.Item className="ml-1" label="UDF 2">
                        {getFieldDecorator("udf2", {
                            rules: validations.udf2
                        })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                    </Form.Item>

                    <Form.Item className="ml-1" label="UDF 3">
                        {getFieldDecorator("udf3", {
                            rules: validations.udf3
                        })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                    </Form.Item>

                    <Form.Item className="ml-1" label="UDF 4">
                        {getFieldDecorator("udf4", {
                            rules: validations.udf4
                        })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                    </Form.Item>

                    <Form.Item className="ml-1" label="UDF 5">
                        {getFieldDecorator("udf5", {
                            rules: validations.udf5
                        })(<Input autoComplete='off' prefix={<Icon type="form" />} />)}
                    </Form.Item>
                </div> : null
            }

            <div className="w-100 d-flex justify-content-end mt-4">
                <Button type="primary" htmlType="submit" loading={props.loading}>Transfer</Button>
            </div>
        </Form>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

TransferRequestForm = Form.create()(TransferRequestForm);

export default connect(mapStateToProps)(TransferRequestForm);